import { render, staticRenderFns } from "./mvTranslator.vue?vue&type=template&id=c32ace14&scoped=true&"
import script from "./mvTranslator.vue?vue&type=script&lang=js&"
export * from "./mvTranslator.vue?vue&type=script&lang=js&"
import style0 from "./mvTranslator.vue?vue&type=style&index=0&id=c32ace14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32ace14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VMenu,VProgressCircular})
